<div class="zommer-wrapper" id="bs-refl">
  <div class="zoomer-content">
    <ng-content></ng-content>
  </div> 
</div>